<template>
  <div>
    <iModal
      title="编辑证件"
      v-model="showModal"
      class-name="vertical-center-modal"
      width="600px"
      :mask-closable="false"
      @on-cancel="cancel"
    >
      <div class="admin-add">
        <div class="admin-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="100"
          >
            <FormItem label="胸卡类型：" :required="true">
              <Select v-model="formInline.BadgeType" :disabled="true">
                <Option v-for="item in typeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
            <FormItem label="公司名称：" :required="true">
              <Input type="text" v-model="formInline.CompanyName" :disabled="true"></Input>
            </FormItem>
            <!-- <FormItem label="地址：">
              <Input type="text" v-model="formInline.Address" placeholder="请输入地址"></Input>
            </FormItem> -->
            <FormItem label="姓名：" prop="FirstName">
              <Input type="text" v-model="formInline.FirstName" placeholder="请输入姓名"></Input>
            </FormItem>
            <FormItem label="身份证号：" prop="IdCard">
              <Input type="text" v-model="formInline.IdCard" placeholder="请输入身份证号"></Input>
            </FormItem>
            <!-- <FormItem label="部门：">
              <Input type="text" v-model="formInline.Department" placeholder="请输入部门"></Input>
            </FormItem>
            <FormItem label="手机：">
              <Input type="text" v-model="formInline.Mob" placeholder="请输入手机"></Input>
            </FormItem> -->
            <FormItem label="电话：" prop="Tel">
              <Input type="text" v-model="formInline.Tel" placeholder="请输入电话"></Input>
            </FormItem>
            <!-- <FormItem label="传真：">
              <Input type="text" v-model="formInline.Fax" placeholder="请输入传真"></Input>
            </FormItem> -->
            <FormItem label="邮箱：" prop="Email">
              <Input type="text" v-model="formInline.Email" placeholder="请输入邮箱"></Input>
            </FormItem>
            <FormItem label="职务：" prop="JobTitle">
              <Input type="text" v-model="formInline.JobTitle" placeholder="请输入职务"></Input>
            </FormItem>
            <!-- <FormItem label="个人邮箱：">
              <Input type="text" v-model="formInline.PersonalEmail" placeholder="请输入个人邮箱"></Input>
            </FormItem> -->
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button style="width:90px;" @click="cancel">取消</Button>
        <Button style="width:90px;" type="primary" @click="handleSubmit('formInline')">确定</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { validator } from "@/other/validator";
import {  mapGetters, mapActions } from "vuex";

export default {
  name: "addCert",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    editInfo: {
      type: Object,
      default: {}
    },
    type: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      showModal: false,
      formInline: {
        BadgeType: "展商证",
        CompanyName: "",
        Address: "",
        FirstName: "",
        JobTitle: "",
        Department: "",
        Mob: "",
        Tel: "",
        Fax: "",
        Email: "",
        PersonalEmail: "",
        IdCard: ""
      },
      ruleInline: {
        // 效验规则
        FirstName: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur"
          }
        ], 
        IdCard: [
          {
            required: true,
            message: "请输入身份证号",
            trigger: "blur"
          }
        ], 
        Tel: [
          {
            required: true,
            message: "请输入电话",
            trigger: "blur"
          }
        ],
        Email: [
          {
            required: true,
            message: "请输入邮箱",
            trigger: "blur"
          }
        ],
        JobTitle: [
          {
            required: true,
            message: "请输入职务",
            trigger: "blur"
          }
        ],
        // Mob: validator.phone,
      },
      typeList: [
        {
          value: "展商证",
          label: "展商证",
        }
      ]
    };
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      this.init();
      if (!val) this.$emit("close");
    },
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",  
      exhibition: "loginModule/getExhibition",
      joinInfo:'loginModule/getJoinInfo'
    }),
    exhibitonId() { return this.exhibition.id},
    header() { return this.$store.state.header},
  },
  methods: {
    ...mapActions({
      realAuth: "realAuth"
    }),
    init() {
      if (this.editInfo) {
        this.formInline.CompanyName = this.editInfo.companyName;
        this.formInline.FirstName = this.editInfo.firstName;
        this.formInline.IdCard = this.editInfo.idCard;
        this.formInline.Tel = this.editInfo.tel;
        this.formInline.Email = this.editInfo.email;
        this.formInline.JobTitle = this.editInfo.jobTitle;
      }
    },
    async handleSubmit(name,e) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;

      // 实名验证
      let info = await this.realAuth({
        idcard: this.formInline.IdCard,
        name: this.formInline.FirstName,
      });
      if (!info || !info.successed) {
        this.$Message.warning(info.msg);
        return;
      }
      this.loading = true;

      if (this.type === 0) {
        this.editLink(form);
      } else {
        this.editLink2(form);
      }
    },
    editLink(form){
        let body = {
          "Id":this.editInfo.id,
          "JoinId":this.joinInfo.joinId,
          "ExhibitonId":this.exhibitonId, 
          "SetValues":{
            "FirstName": form.FirstName,
            "JobTitle": form.JobTitle,
            "Tel": form.Tel,
            "Email": form.Email,
            "Idcard": form.IdCard,
          }
        }
        this.$http.put('/api/DeExCardDown/PutUp',body,this.header)
                .then(res=>{
                  if(res.status === 200 && res.data.successed){
                     this.loading = false;
                     this.$Message.success("修改成功，请等待审核！");
                     this.cancel();
                   }else{
                     this.loading = false;
                     this.$Message.error("修改失败，请重新尝试");
                   }
                })

    },
    editLink2(form){
        let body = {
          "Id":this.editInfo.id,
          "SetValues":{
            "FirstName": form.FirstName,
            "JobTitle": form.JobTitle,
            "Tel": form.Tel,
            "Email": form.Email,
            "Idcard": form.IdCard,
          }
        }
        this.$http.put('/api/DeExCardDown',body,this.header)
                .then(res=>{
                  if(res.status === 200 && res.data.successed){
                     this.loading = false;
                     this.$Message.success("修改成功！");
                     this.cancel();
                   }else{
                     this.loading = false;
                     this.$Message.error("修改失败，请重新尝试");
                   }
                })

    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel() {
      this.$refs["formInline"].resetFields();
      this.formInline.CompanyName = "";
      this.formInline.FirstName = "";
      this.formInline.JobTitle = "";
      this.formInline.Tel = "";
      this.formInline.Email = "";
      this.formInline.IdCard = "";
      this.$emit("close");
    }
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
    img {
      width: 150px;
      height: 150px;
    }
  }
  .form-code-item {
    position: relative;
    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;
      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>

